import React from "react"
import Layout from "@/components/layout"
import Navigation from "@/components/reservations/navigation"
import { useVenue } from "@/contexts/venue"
import { useQuery } from "@apollo/client/react"
import { GetVenueFullDocument, type GetVenueFullQuery, type GetVenueFullQueryVariables } from "@/graphql/graphql"
import { PlanViewer, type VenuePlanData } from "@/components/plan"
import i18n from "@/i18n"

const VenuePlanPage = () => {
  const { venue } = useVenue()

  const { data: venueFullData, loading } = useQuery<GetVenueFullQuery, GetVenueFullQueryVariables>(
    GetVenueFullDocument,
    {
      variables: { slug: venue.slug },
    },
  )

  const venuePlans = (venueFullData?.venue?.plans || []) as VenuePlanData[]
  const tables = venue.tables?.map((t: any) => ({ id: t.id, name: t.name })) || []

  return (
    <Layout
      title={i18n.t("app.reservations_navigation.venue_plan")}
      flex
      data-testid="panel-reservations-venue-plan-page"
    >
      <Navigation />

      <div className="flex-1 flex flex-col min-h-0 bg-white rounded-lg border border-gray-200 overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center h-full text-gray-500">
            {i18n.t("app.common.loading") || "Loading..."}
          </div>
        ) : venuePlans.length > 0 ? (
          <PlanViewer venuePlans={venuePlans} tables={tables} showSchedule={false} showTableLabels={true} />
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">
            {i18n.t("app.reservations_venue_plan.no_plans") || "No venue plans available"}
          </div>
        )}
      </div>
    </Layout>
  )
}

export default VenuePlanPage
